var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { fromAccount } from '@banking/api/utils/unified-account';
import { AccountState, Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { sumAmounts } from '@banking/api/utils/bank-account';
let SavingsAccounts = (_dec = computed('bankingAccountApi.savingsBalances'), _dec2 = computed('bankingAccountApi.savingsBalances'), _dec3 = computed('bankingAccountApi.savingsBalances'), _dec4 = computed('sfsAccountApi.primaryAccount'), _dec5 = computed('accounts.@each.{name,state}'), _dec6 = computed('accounts.@each.{id,state}'), _dec7 = computed('savingsBankAccounts.@each.availableBalance'), _dec8 = computed('availableBalances.@each.{amount,currency}'), _dec9 = computed('savingsBankAccounts.@each.pendingBalance'), _dec10 = computed('pendingBalances.@each.{amount,currency}'), _dec11 = computed('savingsBankAccounts.@each.totalBalance'), _dec12 = computed('totalBalances.@each.{amount,currency}'), _dec13 = computed('totalBalance.{amount,currency}', 'totalPendingBalance.amount'), _class = class SavingsAccounts extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor, this);
    _initializerDefineProperty(this, "sfsAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor3, this);
  }
  get merchantOwner() {
    return Owner.create({
      id: this.capitalEngineContext.sessionContext.merchantToken,
      type: OwnerType.MERCHANT
    });
  }
  get primaryAccount() {
    return this.bankingAccountApi.savingsBalances.find(account => {
      return account.metadata?.savingsAccount?.isPrimary;
    });
  }
  get accounts() {
    return this.bankingAccountApi.savingsBalances;
  }
  get savingsBankAccounts() {
    return this.bankingAccountApi.savingsBalances.filter(({
      state
    }) => state !== AccountState.CLOSED).map(balance => fromAccount(balance));
  }
  get primarySfsAccount() {
    return this.sfsAccountApi.primaryAccount;
  }
  get openAccountNames() {
    return this.accounts.filter(account => {
      return account.name !== undefined && account.state !== AccountState.CLOSED;
    }).map(account => account.name.toLowerCase());
  }
  get openAccountIds() {
    return this.accounts.filter(account => account.state !== AccountState.CLOSED).map(account => account.id);
  }
  get availableBalances() {
    return this.savingsBankAccounts.map(account => {
      return account.availableBalance;
    });
  }
  get totalAvailableBalance() {
    return sumAmounts(this.availableBalances);
  }
  get pendingBalances() {
    return this.savingsBankAccounts.map(account => {
      return account.pendingBalance;
    });
  }
  get totalPendingBalance() {
    return sumAmounts(this.pendingBalances);
  }

  // Total balances include available + settled funds
  get totalBalances() {
    return this.savingsBankAccounts.map(account => {
      return account.totalBalance;
    });
  }
  get totalBalance() {
    return sumAmounts(this.totalBalances);
  }
  get totalAndPendingBalance() {
    const summedAmount = this.totalBalance.amount + this.totalPendingBalance.amount;
    const currency = this.totalBalance.currency;
    return Money.create({
      amount: summedAmount,
      currency
    });
  }

  /**
   * Return a promise which resolves when all savings accounts have been fetched
   * from the server.
   */
  load() {
    return this.bankingAccountApi.listAccounts([this.merchantOwner]);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "primaryAccount", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "primaryAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "accounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savingsBankAccounts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "savingsBankAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "primarySfsAccount", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "primarySfsAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAccountNames", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "openAccountNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAccountIds", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "openAccountIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableBalances", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "availableBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalAvailableBalance", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "totalAvailableBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pendingBalances", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "pendingBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalPendingBalance", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "totalPendingBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalBalances", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "totalBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalBalance", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "totalBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalAndPendingBalance", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "totalAndPendingBalance"), _class.prototype), _class);
export { SavingsAccounts as default };